import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const CondolenceObituaryRecipients = () => {
  const navigate = useNavigate();
  const [recipients, setRecipients] = useState([]);
  const [source, setSource] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const load = useCallback(() => {
    fetch('/api/condolence/admin/obituary-recipients', { credentials: 'include' })
      .then(res => {
        if (res.status === 403) { navigate('/condolence/menu'); return null; }
        if (!res.ok) { navigate('/condolence'); return null; }
        return res.json();
      })
      .then(data => {
        if (data) {
          setRecipients(data.recipients || []);
          setSource(data.source || '');
        }
      })
      .catch(() => setError('一覧の取得に失敗しました'))
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => { load(); }, [load]);

  const updateField = (id, value) => {
    setRecipients(prev => prev.map(r => r.id === id ? { ...r, obituary_to: value } : r));
  };

  const handleSave = async (target) => {
    setSaving(target.id);
    setMessage('');
    setError('');
    try {
      const res = await fetch('/api/condolence/admin/obituary-recipients', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          target_id: target.id,
          obituary_to: target.obituary_to || '',
        }),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage(`ID ${target.id}（${target.department}）の自店役職者を保存しました`);
      } else {
        setError(data.error || '保存に失敗しました');
      }
    } catch {
      setError('通信エラーが発生しました');
    } finally {
      setSaving(null);
    }
  };

  return (
    <div className="form-page">
      <header className="form-header" style={{ background: '#37474f' }}>
        <button className="back-button" onClick={() => navigate('/condolence/menu')}>← 戻る</button>
        <h1>店舗別 自店役職者（メールグループD）</h1>
      </header>

      <main className="form-main">
        <div className="section-bar" style={{ background: '#eceff1' }}>
          <span className="icon">✉️</span>
          <span className="title" style={{ color: '#37474f' }}>店舗ごとの役職者メールアドレス</span>
        </div>

        <div className="form-card">
          <p style={{ fontSize: '13px', color: '#666', marginBottom: '12px' }}>
            ※ 訃報送信先のうち「自店役職者（メールグループD）」に該当するアドレスです。複数指定する場合はカンマ区切り。<br />
            ※ A/B/C（本社・全店役職・管理部門）は<a href="/condolence/mail-groups" style={{ color: '#37474f' }}>メールグループ設定</a>で別途編集してください。
          </p>

          {source === 'excel' && (
            <div style={{
              background: '#fff3e0', border: '1px solid #ffcc80', borderRadius: '6px',
              padding: '12px', marginBottom: '16px', color: '#e65100', fontSize: '14px'
            }}>
              現在 Excel フォールバックで動作中のため、編集機能は無効です（本番DB接続時のみ有効）。
            </div>
          )}
          {message && (
            <div style={{
              background: '#e8f5e9', border: '1px solid #66bb6a', borderRadius: '6px',
              padding: '12px', marginBottom: '16px', color: '#2e7d32'
            }}>{message}</div>
          )}
          {error && <div className="error-message">{error}</div>}

          {loading ? (
            <p style={{ textAlign: 'center', color: '#666' }}>読み込み中...</p>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #37474f' }}>
                  <th style={thStyle}>ID</th>
                  <th style={thStyle}>部署名</th>
                  <th style={thStyle}>自店役職者（D）TO</th>
                  <th style={thStyle}>操作</th>
                </tr>
              </thead>
              <tbody>
                {recipients.map(r => (
                  <tr key={r.id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={tdStyle}>{r.id}</td>
                    <td style={{ ...tdStyle, minWidth: '160px' }}>{r.department}</td>
                    <td style={tdStyle}>
                      <input
                        type="text"
                        value={r.obituary_to || ''}
                        onChange={(e) => updateField(r.id, e.target.value)}
                        placeholder="aaa@..., bbb@..."
                        style={inputStyle}
                        disabled={source === 'excel'}
                      />
                    </td>
                    <td style={tdStyle}>
                      <button
                        onClick={() => handleSave(r)}
                        disabled={saving === r.id || source === 'excel'}
                        style={{
                          padding: '6px 12px', fontSize: '13px',
                          background: source === 'excel' ? '#bdbdbd' : '#37474f',
                          color: 'white', border: 'none', borderRadius: '4px',
                          cursor: source === 'excel' ? 'not-allowed' : 'pointer',
                        }}
                      >
                        {saving === r.id ? '保存中...' : '保存'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </main>
    </div>
  );
};

const thStyle = {
  textAlign: 'left', padding: '12px 8px', color: '#37474f', fontSize: '13px', fontWeight: '600'
};
const tdStyle = {
  padding: '8px', fontSize: '13px', color: '#333', verticalAlign: 'middle'
};
const inputStyle = {
  width: '100%', minWidth: '260px', padding: '6px 8px',
  border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px'
};

export default CondolenceObituaryRecipients;
